// removed by extract-text-webpack-plugin
module.exports = {"storyLine":"styles-story-line__storyLine___208Ti","inner":"styles-story-line__inner___2eh5l","imageCol":"styles-story-line__imageCol___3w2Gv","title":"styles-story-line__title___8r0-Z","postedOn":"styles-story-line__postedOn___1OiCJ","rotate":"styles-story-line__rotate___3YVBc","fadein":"styles-story-line__fadein___22w9a","slideFromRight":"styles-story-line__slideFromRight___2dL6T","waves":"styles-story-line__waves___2DmMC"};


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/containers/NewsEvents/styles-story-line.scss
// module id = ./resources/assets/js/containers/NewsEvents/styles-story-line.scss
// module chunks = 0